import Icon from "@ant-design/icons";


const Svg = () => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.02594 8L18.4545 8" stroke="#959FA3" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M7.54547 1.45459L1.00002 8.00004L7.54547 14.5455" stroke="#959FA3" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const MyIcon = (props) => <Icon component={Svg} {...props}/>
